export default __webpack_public_path__ + "static/media/team50.0085d84e.JPG";